export const PERMS = {
    READ: 'service_jobs.read',
    UPDATE: 'service_jobs.update',
    DELETE: 'service_jobs.delete',
    CREATE: 'service_jobs.create',
    EXPORT: 'service_jobs.export',
}
